export default __webpack_public_path__ + "static/media/Sync2_.57b55112.svg";